import type { CommandId } from "./commandIds.js";

export type CommandHandler = () => void;

/**
 * WEB mapping of ICommandDispatcher (WEB_IMPLEMENTATION_LAYER.md §2).
 */
export class CommandDispatcher {
  private readonly handlers = new Map<string, CommandHandler>();
  private readonly enabled = new Map<string, boolean>();
  private readonly checked = new Map<string, boolean>();

  registerHandler(commandId: CommandId | string, handler: CommandHandler): void {
    this.handlers.set(commandId, handler);
    if (!this.enabled.has(commandId)) this.enabled.set(commandId, true);
  }

  unregisterHandler(commandId: string): void {
    this.handlers.delete(commandId);
    this.enabled.delete(commandId);
    this.checked.delete(commandId);
  }

  setCommandEnabled(commandId: string, enabled: boolean): void {
    this.enabled.set(commandId, enabled);
  }

  isCommandEnabled(commandId: string): boolean {
    return this.enabled.get(commandId) !== false;
  }

  setCommandChecked(commandId: string, checked: boolean): void {
    this.checked.set(commandId, checked);
  }

  isCommandChecked(commandId: string): boolean {
    return this.checked.get(commandId) === true;
  }

  executeCommand(commandId: string): boolean {
    if (!this.isCommandEnabled(commandId)) return false;
    const fn = this.handlers.get(commandId);
    if (!fn) return false;
    fn();
    return true;
  }
}
